import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Layout } from './Components/Layout'
import { NavigationContextProvider } from './contexts/NavigationContextProvider'
import { IAuthContext } from './types'
import { logout, setupInterceptors } from './services/opw.api'
import AppRoutes from '../src/routes/AppRoutes'
import AuthContext from './contexts/AuthContext'
import { IPublicClientApplication } from '@azure/msal-browser'

export const handleLogOut = async (
  authContext: IAuthContext,
  instance: IPublicClientApplication,
) => {
  try {
    await logout(authContext?.data?.token)
  } finally {
    authContext?.updateData('token', '')
    authContext?.updateData('user', null)

    document.cookie.split(';').forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/')
    })

    instance.setActiveAccount(null)
  }
}

export const clearSessionAndRedirect = (
  authContext: IAuthContext,
  navigate: (path: string) => void,
) => {
  try {
    authContext?.updateData('token', '')
    authContext?.updateData('user', null)
  } catch (e) {
    console.log('Storage clear failed', e)
  }
  document.cookie.split(';').forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, '')
      .replace(/=.*/, '=;expires=' + new Date(0).toUTCString() + ';path=/')
  })
  navigate('/login')
}

function App() {
  const navigate = useNavigate()
  const authContext = useContext(AuthContext)

  useEffect(() => {
    setupInterceptors(() => {
      console.log('Session expired, cleaning up...')
      clearSessionAndRedirect(authContext, navigate)
    })
  }, [])

  return (
    <div className='App' style={{ height: '100vh', overflow: 'hidden' }}>
      <NavigationContextProvider>
        <Layout>
          <AppRoutes />
        </Layout>
      </NavigationContextProvider>
    </div>
  )
}

export default App
